export const getDefaultState = () => {
  const defaultState = {
    compsType: 'company',
    classificationSelected: 'Industry Group (L2)',
    outliersIncluded: false,
    initialising: false,
    secondInitPending: false,
    hasPersistedState: false,
    originalColumnSet: [],
    customColumnSet: [],
    filterItemMap: [],
    sortInfo: {},
    fxSetting: {
      company: 'RAW',
      sector: 'USD',
    },
  }
  return defaultState
}
export default getDefaultState()
